"use strict";
import { css } from "@emotion/react";
import { clearfix } from "../../../../styles/style-mixins.js";
import styled from "@emotion/styled";
import { composeBreakpoints, wrapStyles } from "../utils.js";
const baseStyles = css`
  position: relative;
`;
const createGutterStyles = (theme, grid) => {
  const styles = `
      margin-left: calc(-${grid.gutter} / 2);
      margin-right: calc(-${grid.gutter} / 2);
    `;
  return wrapStyles(theme, grid.breakpoint, styles);
};
const gutterStyles = ({ theme }) => composeBreakpoints(createGutterStyles, theme, theme.grid);
const Row = styled("div")(baseStyles, clearfix, gutterStyles);
export {
  Row
};
